var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAASklEQVR42mMYxuDOndv5yGyyDADiTSAMNcCCGE2biMF4DUhPT5+DD0MNiMRrQE5OzjRceCQYQAjDDcADImEYWQMGJhbANAzePAMAhzDKn88W058AAAAASUVORK5CYII=";
  export default img;